import formatNumber from 'format-number'

export const budgetFormat = number => {
  const myFormat = formatNumber({
    prefix: '¥',
    round: 0,
  })
  return myFormat(number)
}

export const budgetFormatWithoutUnit = number => {
  const myFormat = formatNumber({
    round: 0,
  })
  return myFormat(number)
}

export const revenueBuyingCurrencyFormat = number => {
  const myFormat = formatNumber({
    prefix: '¥',
    round: 0,
  })
  return myFormat(number)
}

export const cpcFormat = number => {
  const myFormat = formatNumber({
    prefix: '¥',
    round: 0,
  })
  return myFormat(number)
}

export const cpmFormat = number => {
  const myFormat = formatNumber({
    prefix: '¥',
    round: 0,
  })
  return myFormat(number)
}

export const ctrFormat = number => {
  const myFormat = formatNumber({
    suffix: ' %',
    round: 2,
  })
  return myFormat(number * 100)
}

export const impsFormat = number => {
  const myFormat = formatNumber({
    round: 0,
  })
  return myFormat(number)
}

export const clicksFormat = number => {
  const myFormat = formatNumber({
    round: 0,
  })
  return myFormat(number)
}

export const lngFormat = number => {
  const myFormat = formatNumber({
    round: 3,
  })
  return myFormat((number - 139) * 1000)
}

export const latFormat = number => {
  const myFormat = formatNumber({
    round: 3,
  })
  return myFormat((number - 35) * 1000)
}
